export default __webpack_public_path__ + "media/share-orange.c680a548.svg";